module.exports = __webpack_public_path__ + "static/media/bg2.456b47bc.jpg";